// import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';

export function MainPageButton() {
    const navigate = useNavigate();

    const redirectToMain = () => {
        navigate(`/`);
    };

    return (
        <ButtonComponent onClick={redirectToMain}>
            Main Page
        </ButtonComponent>
    );
}
